// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ccS7W","title":"Info_title__1KE57","selects":"Info_selects__1rnkl","requiredAsterisk":"Info_requiredAsterisk__18G4g"};